<div *transloco="let t; read: 'profile-list-search-sort'"
  class="search-sort-container"
  role="region"
  [class.ghost]="isInitialLoad()"
  [attr.aria-label]="t('aria_search_sort')">
  <sl-profile-list-search [availableSearchByFilters]="searchByFilters$ | async"/>

  <div class="input-wrapper with-btn">
    <accredible-select-input icon="icon-sort"
      [formControlRef]="sortFormControl"
      [hideLabel]="true"
      [label]="t('sort_by')"
      [options]="sortOptions()"
      [noErrorMargin]="true"/>

    @if (showFiltersButton()) {
      <button mat-stroked-button
        id="openFilters"
        class="mat-default btn-mobile-filters"
        type="button"
        (click)="openMobileFiltersMenu()">
        <div class="btn-text">
          <div>
            <accredible-icon icon="filters"/>
            {{ t('filters') }}
          </div>
          <accredible-icon icon="field-dropright"/>
        </div>
      </button>
    }
  </div>
</div>
